import { TemplatesApi } from '../../../api/templatesApi';
import { DialogProps } from '../../../interfaces/Templates';
import withSnackbar from '../../../shared/components/withSnackbar';
import { EMPTY_STRING } from '../../../shared/constants/constants';
import {
	SovosDialog,
	SovosDialogTitle,
	SovosDialogContent,
	SovosDialogActions,
	SovosButton,
	SovosTextField,
} from 'mosaic-react';
import React, { useState, useEffect, ChangeEvent } from 'react';

const RenameTemplateDialog: React.FC<DialogProps> = (props: DialogProps) => {
	const { isDialogOpen, setIsDialogOpen, template, snackbarData } = props;
	const [newTemplateName, setNewTemplateName] = useState<string>(EMPTY_STRING);
	const [isSaving, setIsSaving] = useState<boolean>(false);
	const [errorTemplateName, setErrorTemplateName] = useState<string>(EMPTY_STRING);

	const handleNameChange = (event: ChangeEvent<HTMLInputElement>): void => {
		setNewTemplateName(event.target.value);
		setErrorTemplateName(!event.target.value ? 'Template Name is required.' : EMPTY_STRING);
	};

	useEffect(() => {
		if (isDialogOpen) {
			setNewTemplateName(template.name);
			setErrorTemplateName(EMPTY_STRING);
		}
	}, [template, isDialogOpen]);

	const handleClose = (): void => {
		if (!isSaving) {
			setIsDialogOpen(false);
		}
	};

	const handleSave = (): void => {
		if (!errorTemplateName && isDialogOpen) {
			if (newTemplateName !== template.name) {
				const selectedTemplateId = template.id;
				setIsSaving(true);
				TemplatesApi.renameTemplate(selectedTemplateId, newTemplateName)
					.then(response => {
						if (response.data.status === 200) {
							snackbarData({ message: 'Template name updated', variant: 'confirmation', open: true });
						} else {
							snackbarData({
								message: 'Unable to rename template. Please try again later.',
								variant: 'error',
								open: true,
							});
						}
						setIsSaving(false);
						setIsDialogOpen(false);
					})
					.catch(error => {
						if (error.response.data.status === 400) {
							setErrorTemplateName(error.response.data.errors[0].message);
							setIsSaving(false);
						}
					});
			} else {
				setIsDialogOpen(false);
			}
		}
	};

	return (
		<SovosDialog open={isDialogOpen} onClose={handleClose}>
			<SovosDialogTitle>Rename Template</SovosDialogTitle>
			<SovosDialogContent>
				<p>Enter a new name below. Once saved, you&lsquo;ll be able to apply this template to future imports.</p>
				<div>
					<SovosTextField
						onChange={handleNameChange}
						placeholder='Template Name'
						value={newTemplateName}
						autoFocus
						fullWidth
						error={Boolean(errorTemplateName)}
						helperText={errorTemplateName}
					/>
				</div>
			</SovosDialogContent>
			<SovosDialogActions>
				<SovosButton variant={'text'} onClick={handleClose} disabled={isSaving}>
					Cancel
				</SovosButton>
				<SovosButton onClick={handleSave} disabled={isSaving}>
					Save Template
				</SovosButton>
			</SovosDialogActions>
		</SovosDialog>
	);
};

export default withSnackbar(RenameTemplateDialog);
